import { createContext, useState } from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import Cookies from "js-cookie";
import getUserData from "../store/user/GetUserData";
import getUserBooks from "../store/user/userBooks/UserBooks";
import getUserCartoons from "../store/user/userCartoons/UserCartoons";
import getUserConfigs from "../store/user/userConfigs/UserConfigs";

export const UserContext = createContext({
  user: {},
  setUser: (user) => user,
  loading: true,
  setLoading: () => {},
  refetchUser: async () => {}
});

export function UserContextProvider({ children }) {
  const dispatch = useDispatch();
  const [user, setUser] = useState({})
  const [loading, setLoading] = useState(true)
  const token = Cookies.get("auth_token");

  async function loadUser() {
    if (!token) {
      setLoading(false);
      return;
    }

    try {
      setLoading(true);

      const [userRes, libraryRes, cartoonsRes, configsRes] = await Promise.all([
        dispatch(getUserData(token)),
        dispatch(getUserBooks(token)),
        dispatch(getUserCartoons(token)),
        dispatch(getUserConfigs(token))
      ]);

      setUser({
        ...userRes,
        ...libraryRes,
        ...cartoonsRes,
        ...configsRes
      });
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadUser();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const userContext = { user, setUser, loading, setLoading, refetchUser: loadUser };

  return <UserContext.Provider value={userContext}>{children}</UserContext.Provider>
}